import React from 'react'

export const Footer = () => {
  return (
    <section className='footerSection'>
        <div className='text-center text-light'>
            <p className='fs-4'>Site built and maintained by Piyush Kesarwani. Copyrights reserved @ 2022</p>
        </div>
    </section>
  )
}
